/* eslint-disable @typescript-eslint/no-explicit-any */
import { Liquid } from "liquidjs";

const engine = new Liquid({ cache: false });

export function renderProjectTemplate(
  template: string,
  elementData: any,
): Promise<string> {
  return engine.parseAndRender(template, { ...elementData });
}
